(function () {
  if (customElements.get('ce-cart-quantity') !== undefined) {
    return;
  }

  class CartQuantity extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        cart: 'ce-cart',
        input: '[data-cart-quantity-input]',
        buttonDecrement: '[data-cart-quantity-button="decrement"]',
        buttonIncrement: '[data-cart-quantity-button="increment"]',
        buttonRemove: '[data-cart-quantity-button="remove"]',
      };

      this.elements = null;

      this.debounceCartChange = null;

      this.handleChangeInput = this.handleChangeInput.bind(this);
      this.handleBlurInput = this.handleBlurInput.bind(this);
      this.handleClickButtonDecrement = this.handleClickButtonDecrement.bind(this);
      this.handleClickButtonIncrement = this.handleClickButtonIncrement.bind(this);
      this.handleClickButtonRemove = this.handleClickButtonRemove.bind(this);
    }

    parsedCallback() {
      this.elements = {
        cart: document.querySelector(this.selectors.cart),
        input: this.querySelector(this.selectors.input),
        buttonDecrement: this.querySelector(this.selectors.buttonDecrement),
        buttonIncrement: this.querySelector(this.selectors.buttonIncrement),
        buttonRemove: this.querySelector(this.selectors.buttonRemove),
      };

      this.elements.input.addEventListener('change', this.handleChangeInput);
      this.elements.input.addEventListener('blur', this.handleBlurInput);
      this.elements.buttonDecrement.addEventListener('click', this.handleClickButtonDecrement);
      this.elements.buttonIncrement.addEventListener('click', this.handleClickButtonIncrement);
      this.elements.buttonRemove.addEventListener('click', this.handleClickButtonRemove);
    }

    disconnectedCallback() {
      this.elements.input.removeEventListener('change', this.handleChangeInput);
      this.elements.input.removeEventListener('blur', this.handleBlurInput);
      this.elements.buttonDecrement.removeEventListener('click', this.handleClickButtonDecrement);
      this.elements.buttonIncrement.removeEventListener('click', this.handleClickButtonIncrement);
      this.elements.buttonRemove.removeEventListener('click', this.handleClickButtonRemove);
    }

    handleChangeInput() {
      if (this.elements.input.value > 1) {
        this.elements.buttonDecrement.removeAttribute('aria-disabled');
      } else {
        this.elements.buttonDecrement.setAttribute('aria-disabled', 'true');
      }

      const key = this.elements.input.dataset.key;
      const quantity = this.elements.input.value;

      clearTimeout(this.debounceCartChange);
      this.debounceCartChange = setTimeout(() => {
        this.elements.cart.change(key, quantity);
      }, 200);
    }

    handleBlurInput() {
      const value = parseInt(this.elements.input.value) || 0;
      const newValue = Math.max(0, value);

      if (newValue !== value) {
        this.elements.input.value = newValue;
        this.elements.input.dispatchEvent(new Event('change'));
      }
    }

    handleClickButtonDecrement(event) {
      if (this.elements.buttonDecrement.hasAttribute('aria-disabled')) {
        event.preventDefault();
        return;
      }

      const value = parseInt(this.elements.input.value);
      this.elements.input.value = value - 1;

      this.elements.input.dispatchEvent(new Event('change'));
    }

    handleClickButtonIncrement() {
      const value = parseInt(this.elements.input.value);
      this.elements.input.value = value + 1;

      this.elements.input.dispatchEvent(new Event('change'));
    }

    handleClickButtonRemove(event) {
      event.preventDefault();

      const key = this.elements.buttonRemove.dataset.key;
      const quantity = 0;

      this.elements.cart.change(key, quantity);
    }
  }

  customElements.define('ce-cart-quantity', CartQuantity);
})();
